import React from 'react'
import TocMenu from '@/toc/Menu.jsx'

export const PageToc = () =>
  <TocMenu className="toc"/>

export default PageToc